import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function MapModal({ isOpen, account, onClose }) {
  if (!isOpen || !account) return null;

  const lat = account?.lat || 14.5995;
  const lng = account?.lng || 120.9842;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-xl shadow-xl w-full max-w-2xl flex flex-col" style={{ height: '520px' }}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-border flex-shrink-0">
          <div className="flex items-center gap-2">
            <Icon name="MapPin" size={18} color="var(--color-primary)" strokeWidth={2} />
            <div>
              <h2 className="font-heading text-sm font-semibold text-foreground">{account?.name}</h2>
              <p className="font-caption text-xs text-muted-foreground">{account?.address}</p>
            </div>
          </div>
          <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-muted text-muted-foreground transition-colors" onClick={onClose}>
            <Icon name="X" size={18} color="currentColor" strokeWidth={2} />
          </button>
        </div>
        <div className="flex-1 overflow-hidden rounded-b-xl">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={`GPS location of ${account?.name}`}
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${lat},${lng}&z=14&output=embed`}
          />
        </div>
        <div className="flex items-center justify-between px-5 py-3 border-t border-border flex-shrink-0">
          <span className="font-data text-xs text-muted-foreground">Lat: {lat} · Lng: {lng}</span>
          <Button variant="outline" size="sm" onClick={onClose}>Close</Button>
        </div>
      </div>
    </div>
  );
}